import {Route, Routes} from "react-router-dom";
import Base from "../layout/Base";
import Homepage from "../pages/Homepage";
import EditUser from "../pages/EditUser";
import NotFound from "../pages/NotFound";

const Routing = () => {
    return (
        <Routes>
            <Route path='*' element={<NotFound/>}/>

            <Route element={<Base/>}>
                <Route path='/fe' index={true} element={<Homepage/>}/>
                <Route path='/fe/edit-user/:id' element={<EditUser/>}/>
                <Route path='/fe/edit-user' element={<EditUser/>}/>
            </Route>
        </Routes>
    )
}

export default Routing;
